import React from "react";

export default function PricesTable() {
  const prices = [
    {
      name: "Устная юридическая консультация (разговор, не более одного часа, по одному вопросу)",
      price: "от 1 000",
    },
    {
      name: "Письменная юридическая консультация",
      price: "от 3 000",
    },
    {
      name: "Составление договора, соглашения",
      price: "от 8 000",
    },
    {
      name: "Правовая экспертиза документов, договоров, соглашений",
      price: "от 3 000",
    },
    {
      name: "Досудебное урегулирование спора (претензия, переговоры и т.п.)",
      price: "от 5 000",
    },
    {
      name: "Составление искового заявления, отзыва, возражений на иск",
      price: "от 5 000",
    },
    {
      name: "Составление апелляционной жалобы (отзыва)",
      price: "от 10 000",
    },
    {
      name: "Составление кассационной жалобы (отзыва)",
      price: "от 12 000",
    },
    {
      name: "Составление процессуальных документов (ходатайств)",
      price: "от 3 000",
    },
    {
      name: "Ведение дела в суде одной инстанции (включает составление всех необходимых документов и представительство в суде)",
      price: "от 30 000",
    },
    {
      name: "Абонентское обслуживание граждан и юридических лиц / программы «Персональный юрист», «Юрист компании»",
      price: "по договоренности",
    },
  ];

  return (
    <section id="prices" className="relative container mx-auto py-20 px-4">
      <h2 className="h1 md:text-4xl font-semibold mb-8 uppercase">Цены</h2>

      <p className="text3 mb-10 leading-relaxed max-w-3xl">
        Точную стоимость услуги заранее определить сложно, так как каждая
        ситуация уникальна и требует особого подхода. Цена зависит от двух
        факторов: сложности дела и времени, которое нужно для достижения
        наилучшего результата.
      </p>

      <h3 className="h2 font-semibold mb-6">Примерная стоимость услуг</h3>

      {/* Скрываем таблицу на мобильных */}
      <div className="hidden md:block overflow-x-auto shadow-md rounded-xl border border-gray-200">
        <table className="min-w-full border-collapse">
          <thead className="bg-[#1F2732]">
          <tr>
            <th className="py-3 px-4 text-left text2 font-medium border-b border-gray-600">
              Наименование услуги
            </th>
            <th className="py-3 px-4 text-right text2 font-medium border-b border-gray-600">
              Цена (руб.)
            </th>
          </tr>
          </thead>
          <tbody>
          {prices.map((item, index) => (
            <tr key={index} className="border-b border-gray-200">
              <td className="py-4 px-4 text2">{item.name}</td>
              <td className="w-auto py-4 px-4 text-right font-semibold text2 whitespace-nowrap">
                {item.price}
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>

      {/* Мобильная версия */}
      <div className="md:hidden space-y-4">
        {prices.map((item, index) => (
          <div
            key={index}
            className="p-4 border rounded-xl shadow-sm "
          >
            <div className="text2 font-medium">{item.name}</div>
            <div className="text-right font-semibold text2 mt-2">
              {item.price}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
